import { FulfillmentHoldReason } from "@redotech/shopify-client/admin.graphql";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { Provider } from "../order";
import { ShopifyFulfillmentHoldReason } from "./shopify-fulfillment-schemas";

const FulfillmentHoldSchema_ = z.object({
  holdHandle: z.string(),
  provider: createEnum(Provider, { enumName: "Provider" }).nullish(),
  reason: createEnum(ShopifyFulfillmentHoldReason, {
    enumName: "ShopifyFulfillmentHoldReason",
  }),
  reasonNotes: z.string(),
  placedAt: z.date().nullish(),
});
export const FulfillmentHoldSchema: z.ZodType<FulfillmentHold> =
  FulfillmentHoldSchema_;

export interface FulfillmentHold extends z.infer<
  typeof FulfillmentHoldSchema_
> {}

/**
 * Maps our internal FulfillmentHoldReasons to Shopify's hold reasons
 */
export const FULFILLMENT_HOLD_REASON_MAP: {
  [key in ShopifyFulfillmentHoldReason]: FulfillmentHoldReason;
} = {
  [ShopifyFulfillmentHoldReason.InventoryOutOfStock]:
    FulfillmentHoldReason.InventoryOutOfStock,
  [ShopifyFulfillmentHoldReason.IncorrectAddress]:
    FulfillmentHoldReason.IncorrectAddress,
  [ShopifyFulfillmentHoldReason.AwaitingPayment]:
    FulfillmentHoldReason.AwaitingPayment,
  [ShopifyFulfillmentHoldReason.HighRiskOfFraud]:
    FulfillmentHoldReason.HighRiskOfFraud,
  [ShopifyFulfillmentHoldReason.Other]: FulfillmentHoldReason.Other,
  [ShopifyFulfillmentHoldReason.AwaitingReturnItems]:
    FulfillmentHoldReason.AwaitingReturnItems,
  [ShopifyFulfillmentHoldReason.OnlineStorePostPurchaseCrossSell]:
    FulfillmentHoldReason.OnlineStorePostPurchaseCrossSell,
  [ShopifyFulfillmentHoldReason.UnknownDeliveryDate]:
    FulfillmentHoldReason.UnknownDeliveryDate,
};

/**
 * Maps Shopify's hold reasons to our internal FulfillmentHoldReasons
 */
export const FULFILLMENT_HOLD_REASON_MAP_REVERSE: {
  [key in FulfillmentHoldReason]: ShopifyFulfillmentHoldReason;
} = {
  [FulfillmentHoldReason.InventoryOutOfStock]:
    ShopifyFulfillmentHoldReason.InventoryOutOfStock,
  [FulfillmentHoldReason.IncorrectAddress]:
    ShopifyFulfillmentHoldReason.IncorrectAddress,
  [FulfillmentHoldReason.AwaitingPayment]:
    ShopifyFulfillmentHoldReason.AwaitingPayment,
  [FulfillmentHoldReason.HighRiskOfFraud]:
    ShopifyFulfillmentHoldReason.HighRiskOfFraud,
  [FulfillmentHoldReason.Other]: ShopifyFulfillmentHoldReason.Other,
  [FulfillmentHoldReason.AwaitingReturnItems]:
    ShopifyFulfillmentHoldReason.AwaitingReturnItems,
  [FulfillmentHoldReason.OnlineStorePostPurchaseCrossSell]:
    ShopifyFulfillmentHoldReason.OnlineStorePostPurchaseCrossSell,
  [FulfillmentHoldReason.UnknownDeliveryDate]:
    ShopifyFulfillmentHoldReason.UnknownDeliveryDate,
};
